export default __webpack_public_path__ + "2036b2107585dea3dc413c67bc9f536c.png";